module.exports = __webpack_public_path__ + "static/media/girl_cutting_paper.d2c2b8fc.gif";